var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('audio',{attrs:{"src":_vm.src,"controls":"controls","controlslist":"nodownload"}})}
var staticRenderFns = []

export { render, staticRenderFns }